import { render, staticRenderFns } from "./ResourceFormComponent.vue?vue&type=template&id=39a12132"
import script from "./ResourceFormComponent.vue?vue&type=script&lang=js"
export * from "./ResourceFormComponent.vue?vue&type=script&lang=js"
import style0 from "./ResourceFormComponent.vue?vue&type=style&index=0&id=39a12132&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports